import autumnBannerMobile from '@/assets/images/scheduled-tests/autumn-mobile.webp';
import autumnBanner from '@/assets/images/scheduled-tests/autumn.webp';
import springBannerMobile from '@/assets/images/scheduled-tests/spring-mobile.webp';
import springBanner from '@/assets/images/scheduled-tests/spring.webp';
import summerBannerMobile from '@/assets/images/scheduled-tests/summer-mobile.webp';
import summerBanner from '@/assets/images/scheduled-tests/summer.webp';
import winterBannerMobile from '@/assets/images/scheduled-tests/winter-mobile.webp';
import winterBanner from '@/assets/images/scheduled-tests/winter.webp';
import { Season } from '@/types/components';

interface SeasonBanner {
  mobile: string;
  web: string;
}

export const seasonBanners: Record<Season, SeasonBanner> = {
  [Season.Winter]: { mobile: winterBannerMobile, web: winterBanner },
  [Season.Spring]: { mobile: springBannerMobile, web: springBanner },
  [Season.Summer]: { mobile: summerBannerMobile, web: summerBanner },
  [Season.Autumn]: { mobile: autumnBannerMobile, web: autumnBanner },
};
